import { Navigate, useLocation } from "react-router-dom";

const LEGACY_PREFIX = "/dashboard";

/**
 * Anciennes URLs bookmark / e-mails → préfixe canonique `/dashboard` (même suffixe, query, hash).
 */
export function DashboardV2LegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  if (!pathname.startsWith(LEGACY_PREFIX)) {
    return <Navigate to="/dashboard" replace />;
  }
  const rest = pathname.slice(LEGACY_PREFIX.length);
  const path = rest === "" || rest === "/" ? "" : rest;
  const to = `/dashboard${path}${search}${hash}`;
  return <Navigate to={to} replace />;
}
